import type { McpClientId } from "@arcadeai/ui-kit/mcp-gateway-connect";
import { getMcpClientMeta } from "@arcadeai/ui-kit/mcp-gateway-connect";
import type { JSX } from "react";

type ClientConnectChipGridProps = {
  clientIds: McpClientId[];
  selectedId: McpClientId | null;
  onSelect: (clientId: McpClientId) => void;
};

export function ClientConnectChipGrid({
  clientIds,
  selectedId,
  onSelect,
}: ClientConnectChipGridProps): JSX.Element {
  return (
    <div className="flex flex-wrap gap-2">
      {clientIds.map((clientId) => {
        const { name, logo } = getMcpClientMeta(clientId);
        const isSelected = selectedId === clientId;
        const stateClassName = isSelected
          ? "border-primary/50 bg-primary/10 ring-1 ring-primary/25"
          : "border-border bg-background hover:bg-muted/40";

        return (
          <button
            aria-pressed={isSelected}
            className={`inline-flex w-auto items-center gap-2 rounded-lg border px-3 py-2.5 text-left transition-colors ${stateClassName}`}
            key={clientId}
            onClick={() => onSelect(clientId)}
            type="button"
          >
            <span className="flex shrink-0 [&>svg]:size-4">{logo}</span>
            <span className="whitespace-nowrap font-medium text-muted-foreground text-xs leading-tight">
              {name}
            </span>
          </button>
        );
      })}
    </div>
  );
}
